var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAffiliateStoreTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 7.96875C14.3992 8.88589 15.9301 9.37796 17.5 9.375V6.25C16.3397 6.25 15.2269 5.78906 14.4064 4.96859C13.5859 4.14812 13.125 3.03532 13.125 1.875H10V12.1875C9.99984 12.5789 9.89464 12.9631 9.69539 13.3001C9.49614 13.637 9.21014 13.9143 8.86721 14.103C8.52428 14.2917 8.137 14.385 7.74575 14.3731C7.3545 14.3611 6.97362 14.2444 6.64284 14.0351C6.31207 13.8258 6.04351 13.5316 5.86519 13.1831C5.68686 12.8347 5.6053 12.4448 5.62902 12.0541C5.65273 11.6633 5.78085 11.2861 6.00001 10.9618C6.21917 10.6375 6.52134 10.3779 6.875 10.2102V6.875C4.38828 7.31797 2.5 9.57344 2.5 12.1875C2.5 13.5965 3.05971 14.9477 4.056 15.944C5.05228 16.9403 6.40354 17.5 7.8125 17.5C9.22146 17.5 10.5727 16.9403 11.569 15.944C12.5653 14.9477 13.125 13.5965 13.125 12.1875V7.96875Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffiliateStoreTiktok);
export default __webpack_public_path__ + "static/media/affiliate-store-tiktok.4f4c5b6c6be954cf93d1f6b21bd01923.svg";
export { ForwardRef as ReactComponent };